import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'package:data.universal.outcomes',
    'package:data.universal.orgStructure.checkIns',
    'resource:solutions.apps.summit.pages.allocation',
    'resource:solutions.apps.summit.pages.checkIns',
    'resource:solutions.apps.summit.pages.organization',
    'resource:solutions.apps.summit.pages.outcomeExplore',
    'resource:solutions.apps.summit.pages.outcomesSunburst',
    'resource:solutions.apps.summit.pages.outcomesTable',
    'resource:solutions.apps.summit.pages.outcomesTreeEditor',
    'resource:solutions.apps.summit.pages.archive',
    'resource:solutions.apps.summit.pages.pulse',
    'resource:solutions.apps.summit',
    'resource:solutions.agents.orgChart',
    'resource:solutions.mosaic.pages.summit.outcomesSunburst',
    'resource:solutions.mosaic.pages.summit.outcomesTable',
    'resource:solutions.mosaic.pages.summit.outcomesTreeEditor',
    'resource:solutions.mosaic.pages.summit.outcomeExplore',
    'resource:solutions.mosaic.widgets.summit.outcomeOverview',
    'resource:solutions.mosaic.widgets.summit.outcomesSunburst',
    'resource:solutions.mosaic.widgets.summit.outcomesTreeEditor',
    'resource:solutions.mosaic.widgets.summit.outcomesTable',
    'resource:solutions.mosaic.widgets.summit.outcomeExploreGeneral',
    'resource:solutions.mosaic.widgets.summit.outcomeExploreEmployees',
    'resource:solutions.mosaic.widgets.summit.outcomeExploreExternalSrc',
    'resource:solutions.mosaic.widgets.summit.outcomeExploreMetrics',
  ],
  description: 'Strategic planning and performance monitoring',
  name: 'Summit',
} as const satisfies core.quiver.Package
